import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionReworkOrdersService } from '../services/constructionReworkOrders.service';
import { ConstructionReworkStatsService } from '../services/constructionReworkStats.service';
import type { ConstructionReworkOrder, ReworkFilters } from '../types/construction-rework.types';
import { useState } from 'react';
import { toast } from 'sonner';

export function useConstructionReworkOrders(companyId: string, initialFilters: ReworkFilters = {}) {
  const queryClient = useQueryClient();
  const [filters, setFilters] = useState<ReworkFilters>({
    status: 'all',
    ...initialFilters
  });

  const query = useQuery({
    queryKey: ['construction-rework-orders', companyId, filters],
    queryFn: () => ConstructionReworkOrdersService.getReworkOrders(companyId, filters),
    enabled: !!companyId,
  });

  const statsQuery = useQuery({
    queryKey: ['construction-rework-stats', companyId, filters.projectId],
    queryFn: () => ConstructionReworkStatsService.getReworkStats(companyId, filters.projectId),
    enabled: !!companyId,
  });

  const createMutation = useMutation({
    mutationFn: (data: Partial<ConstructionReworkOrder>) => ConstructionReworkOrdersService.createRework(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-rework-orders'] });
      queryClient.invalidateQueries({ queryKey: ['construction-rework-stats'] });
      toast.success('Tạo lệnh sửa lỗi thành công');
    },
  });

  return {
    reworkOrders: query.data?.data || [],
    total: query.data?.total || 0,
    stats: statsQuery.data,
    isLoading: query.isLoading || statsQuery.isLoading,
    filters,
    setFilters,
    createRework: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
  };
}
